import {defineAsyncComponent} from 'vue';

const NetCoreReportPrintPreview = defineAsyncComponent(() =>
  import('@/views/report/preview/NetCoreReportPrintPreview.vue'),
);
const NetFrameworkReportPrintPreview = defineAsyncComponent(() =>
  import('@/views/report/preview/NetFrameworkReportPrintPreview.vue'),
);

// Form tham số
const C102NSReportParam = defineAsyncComponent(() => import('@/views/report/voucherReport/C102NSReportParam.vue'));
const C102NSND2020ReportParam = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/C102NSND2020ReportParam.vue'),
);
const C102NSQD759ReportParam = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/C102NSQD759ReportParam.vue'),
);
const C402CReportParam = defineAsyncComponent(() => import('@/views/report/voucherReport/C402CReportParam.vue'));
const C27ReportParam = defineAsyncComponent(() => import('@/views/report/voucherReport/C27ReportParam.vue'));
const C27THAQD2030ReportParam = defineAsyncComponent(() => import('@/views/report/voucherReport/C27THAQD2030ReportParam.vue'));
const C402QD759ReportParam = defineAsyncComponent(() => import('@/views/report/voucherReport/C402QD759ReportParam.vue'));

const ReportParam_S05_TT78 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S05_TT78/ReportParam_S05_TT78.vue'),
);

const ReportPreview_S05H = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S05H/ReportPreview_S05H.vue'),
);
const ReportParam_S03_TT78 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S03_TT78/ReportParam_S03_TT78.vue'),
);

const ReportPreview_S03_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S03_THA/ReportPreview_S03_THA.vue'),
);
const ReportParam_S01_THA_QT = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S01_THA_QT/ReportParam_S01_THA_QT.vue'),
);
const ReportParam_S01_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S01_THA/ReportParam_S01_THA.vue'),
);
const ReportParam_StatisticsAccountingDocuments = defineAsyncComponent(() =>
  import(
    '@/views/report/staticReport/ReportParam_StatisticsAccountingDocuments/ReportParam_StatisticsAccountingDocuments.vue'
  ),
);
const ReportParam_S01_SKT_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S01_SKT_THA/ReportParam_S01_SKT_THA.vue'),
);
const ReportParam_B05K = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B05K/ReportParam_B05K.vue'),
);
const ReportParam_B04 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B04/ReportParam_B04.vue'),
);
const ReportParam_B04a = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B04a/ReportParam_B04a.vue'),
);
const ReportParam_B04a_QD2030 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B04a_QD2030/ReportParam_B04a_QD2030.vue'),
);
const ReportParam_AdvancePayment = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_AdvancePayment/ReportParam_AdvancePayment.vue'),
);
const ReportParam_AdvancePaymentQD2030 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_AdvancePayment/ReportParam_AdvancePaymentQD2030.vue'),
);
const B03THAReportParam = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B03THA/B03THAReportParam.vue'),
);

const AssetThanhHoaReportParam = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_AssetThanhHoa/AssetThanhHoaReportParam.vue'),
);

const ReportParam_B05_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B05_THA/ReportParam_B05_THA.vue'),
);

const ReportParam_B05_THA_TT06 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B05_THA_TT06/ReportParam_B05_THA_TT06.vue'),
);

const ReportPreview_B05_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_B05_THA/ReportPreview_B05_THA.vue'),
);

const ReportParam_B06_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B06_THA/ReportParam_B06_THA.vue'),
);

const ReportParam_B07_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B07_THA/ReportParam_B07_THA.vue'),
);

const ReportParam_B07_THA_TT06 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B07_THA_TT06/ReportParam_B07_THA_TT06.vue'),
);

const ReportParam_S06_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S06_THA/ReportParam_S06_THA.vue'),
);
const ReportParam_S04_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S04_THA/ReportParam_S04_THA.vue'),
);

const ReportInwardStock = defineAsyncComponent(() => import('@/views/report/voucherReport/ReportInwardStock.vue'));
const ReportParam_C04_THA = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/ReportParam_C04_THA/ReportParam_C04_THA.vue'),
);
const ReportOutwardStock = defineAsyncComponent(() => import('@/views/report/voucherReport/ReportOutwardStock.vue'));
const ReportParam_D18_THADS = defineAsyncComponent(() => import('@/views/report/voucherReport/ReportParamD18THADS.vue'));

const ReportParam_B01_BCTC_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B01_BCTC_THA/ReportParam_B01_BCTC_THA.vue'),
);
const ReportParam_b04_tha = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_b04_tha/ReportParam_b04_tha.vue'),
);
const ReportParam_b05 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_b05/ReportParam_b05.vue'),
);
const ReportParam_B04_THA_QT = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B04_THA_QT/ReportParam_B04_THA_QT.vue'),
);
const ReportParam_B01_BCDTS_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B01_BCDTS_THA/ReportParam_B01_BCDTS_THA.vue'),
);

const ReportParam_accounts_receivable = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_accounts_receivable/ReportParam_accounts_receivable.vue'),
);

const ReportParam_accounts_payable = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_accounts_payable/ReportParam_accounts_payable.vue'),
);

const ReportParam_c4_02a_kb = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_c4_02a_kb/ReportParam_c4_02a_kb.vue'),
);

const ReportParam_c4_02a_347_kb = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_c4_02a_qd347_kb/ReportParam_c4_02a_347_kb.vue'),
);

const ReportParam_c4_02c_kb = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_c4_02c_kb/ReportParam_c4_02c_kb.vue'),
);

const ReportParam_c4_02b_kb = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/ReportParam_c4_02b_kb/ReportParam_c4_02b_kb.vue'),
);

const ReportParam_D67_THADS = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_D67_THADS/ReportParam_D67_THADS.vue'),
);

const ReportPreview_D67_THADS = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_D67_THADS/ReportPreview_D67_THADS.vue'),
);

const ReportParam_S06a_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S06a_THA/ReportParam_S06a_THA.vue'),
);

const ReportParam_S03_THA_Ledger = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S03_THA_Ledger/ReportParam_S03_THA_Ledger.vue'),
);

const ReportParam_S06_THA_QT = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S06_THA_QT/ReportParam_S06_THA_QT.vue'),
);

const ReportParam_S07_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S07_THA/ReportParam_S07_THA.vue'),
);

const ReportParam_B04THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B04THA/ReportParam_B04THA.vue'),
);

const ReportParam_S08_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S08_THA/ReportParam_S08_THA.vue'),
);

const ReportPreview_S08_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S08_THA/ReportPreview_S08_THA.vue'),
);
const ReportParam_s02_tha_so_cai = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_s02_tha_so_cai/ReportParam_s02_tha_so_cai.vue'),
);

const ReportParam_s02_tha_so_cai_qt = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_s02_tha_so_cai_qt/ReportParam_s02_tha_so_cai_qt.vue'),
);

const ReportParamC24THADS = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/reportParamC24THADS/ReportParamC24THADS.vue'),
);

const ReportParamC25THADS = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/reportParamC25THADS/ReportParamC25THADS.vue'),
);

const ReportParam_S09_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_S09_THA/ReportParam_S09_THA.vue'),
);
const ReportParam_SummaryVoucher = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_SummaryVoucher/ReportParam_SummaryVoucher.vue'),
);
const ReportParam_MS19 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_MS19/ReportParam_MS19.vue'),
);
const ReportParam_SummarySameTypeVoucher = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_SummarySameTypeVoucher/ReportParam_SummarySameTypeVoucher.vue'),
);
const ReportParam_s08 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_s08/ReportParam_s08.vue'),
);

const ReportParam_B01_EnforcementResult = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B01_THA_KQTHA/ReportParam_B01_EnforcementResult.vue'),
);

const ReportParam_B05THA_AssetBalance = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B05THA_AssetBalance/ReportParam_B05THA_AssetBalance.vue'),
);

const ReportPreview_B05THA_AssetBalance = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_B05THA_AssetBalance/ReportPreview_B05THA_AssetBalance.vue'),
);

const ReportPreview_SummaryVoucher = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_SummaryVoucher/ReportPreview_SummaryVoucher.vue'),
);

const ReportPreview_S01_THA_QT = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S01_THA_QT/ReportPreview_S01_THA_QT.vue'),
);

const ReportPreview_s02_tha_so_cai_qt = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_s02_tha_so_cai_qt/ReportPreview_s02_tha_so_cai_qt.vue'),
);

const ReportPreview_AdvancePaymentQD2030 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_AdvancePaymentQD2030/ReportPreview_AdvancePaymentQD2030.vue'),
);

const ReportPreview_AdvancePayment = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_AdvancePayment/ReportPreview_AdvancePayment.vue'),
);

const ReportPreview_s08 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_s08/ReportPreview_s08.vue'),
);

const ReportPreview_S01_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S01_THA/ReportPreview_S01_THA.vue'),
);

const ReportPreview_S09_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S09_THA/ReportPreview_S09_THA.vue'),
);

const ReportPreview_StatisticsAccountingDocuments = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_StatisticsAccountingDocuments/ReportPreview_StatisticsAccountingDocuments.vue'),
);

const ReportPreview_s02_tha_so_cai = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_s02_tha_so_cai/ReportPreview_s02_tha_so_cai.vue'),
);

const ReportPreview_B04_THA_QT = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_B04_THA_QT/ReportPreview_B04_THA_QT.vue'),
);

const ReportPreview_B04_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_B04_THA/ReportPreview_B04_THA.vue'),
);

const ReportPreview_B07_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_B07_THA/ReportPreview_B07_THA.vue'),
);

const ReportPreview_S06_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S06_THA/ReportPreview_S06_THA.vue'),
);

const ReportPreview_S04_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S04_THA/ReportPreview_S04_THA.vue'),
);

const ReportPreview_S07_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S07_THA/ReportPreview_S07_THA.vue'),
);

const ReportPreview_S06_THA_QT = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S06_THA_QT/ReportPreview_S06_THA_QT.vue'),
);

// báo cáo khác 
const ReportParam_B03_THA_TM = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_B03_THA_TM/ReportParam_B03_THA_TM.vue'),
);
const ReportParam_Stat_Justice_Decision = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_Stat_Justice_Decision/ReportParam_Stat_Justice_Decision.vue'),
);

// Tổng hợp báo cáo tài chính
const ReportParam_Summary_TC = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_Summary_TC/ReportParam_Summary_TC.vue'),
);
//sổ chi tiết tờ rời S05-THA
const ReportParam_Pamphlet = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_Pamphlet/ReportParam_Pamphlet.vue'),
);

const ReportPreview_S05_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportPreview_S05_THA/ReportPreview_S05_THA.vue'),
);

const ReportParam_C01_THA = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParam_C01_THA/ReportParam_C01_THA.vue'),
);
//Tùy chọn In
const SettingPrintVoucher = defineAsyncComponent(() =>
  import('@/views/report/staticReport/SettingPrintVoucher/SettingPrintVoucher.vue'),
);
//Tn theo lô
const PrintBatchVoucher = defineAsyncComponent(() =>
  import('@/views/report/staticReport/PrintBatchVoucher/PrintBatchVoucher.vue'),
);

export function registerReport(app) {
  app.component('NetCoreReportPrintPreview', NetCoreReportPrintPreview);
  app.component('NetFrameworkReportPrintPreview', NetFrameworkReportPrintPreview);
  app.component('C102NSReportParam', C102NSReportParam);
  app.component('C102NSND2020ReportParam', C102NSND2020ReportParam);
  app.component('C102NSQD759ReportParam', C102NSQD759ReportParam);
  app.component('C402CReportParam', C402CReportParam);
  app.component('C27ReportParam', C27ReportParam);
  app.component('C27THAQD2030ReportParam', C27THAQD2030ReportParam);
  app.component('C402QD759ReportParam', C402QD759ReportParam);
  app.component('B03THAReportParam', B03THAReportParam);
  app.component('AssetThanhHoaReportParam', AssetThanhHoaReportParam);
  app.component('ReportParam_B05_THA', ReportParam_B05_THA);
  app.component('ReportParam_B05_THA_TT06',ReportParam_B05_THA_TT06)
  app.component('ReportPreview_B05_THA', ReportPreview_B05_THA);
  app.component('ReportParam_B06_THA', ReportParam_B06_THA);
  app.component('ReportParam_B07_THA', ReportParam_B07_THA);
  app.component('ReportParam_B07_THA_TT06',ReportParam_B07_THA_TT06);
  app.component('ReportParam_S05_TT78', ReportParam_S05_TT78);
  app.component('ReportPreview_S05H', ReportPreview_S05H);
  app.component('ReportParam_S03_TT78', ReportParam_S03_TT78);
  app.component('ReportPreview_S03_THA', ReportPreview_S03_THA);
  app.component('ReportParam_S01_THA_QT', ReportParam_S01_THA_QT);
  app.component('ReportParam_S01_THA', ReportParam_S01_THA);
  app.component('ReportParam_StatisticsAccountingDocuments', ReportParam_StatisticsAccountingDocuments);
  app.component('ReportParam_S01_SKT_THA', ReportParam_S01_SKT_THA);
  app.component('ReportParam_AdvancePayment', ReportParam_AdvancePayment);
  app.component('ReportParam_AdvancePaymentQD2030', ReportParam_AdvancePaymentQD2030);
  app.component('ReportParam_B01_BCTC_THA', ReportParam_B01_BCTC_THA);
  app.component('ReportParam_Summary_TC', ReportParam_Summary_TC);
  app.component('ReportParam_b04_tha', ReportParam_b04_tha);
  app.component('ReportParam_b05', ReportParam_b05);
  app.component('ReportParam_B04_THA_QT', ReportParam_B04_THA_QT);
  app.component('ReportParam_B01_BCDTS_THA', ReportParam_B01_BCDTS_THA);
  app.component('ReportParam_accounts_receivable', ReportParam_accounts_receivable);
  app.component('ReportParam_accounts_payable', ReportParam_accounts_payable);
  app.component('ReportParam_c4_02a_kb', ReportParam_c4_02a_kb);
  app.component('ReportParam_c4_02c_kb',ReportParam_c4_02c_kb);
  app.component('ReportParam_c4_02a_347_kb',ReportParam_c4_02a_347_kb)
  app.component('ReportParam_c4_02b_kb', ReportParam_c4_02b_kb);
  app.component('ReportInwardStock', ReportInwardStock);
  app.component('ReportParam_C04_THA', ReportParam_C04_THA);
  app.component('ReportOutwardStock', ReportOutwardStock);
  app.component('ReportParam_D18_THADS',ReportParam_D18_THADS);
  app.component('ReportParam_D67_THADS', ReportParam_D67_THADS);
  app.component('ReportPreview_D67_THADS', ReportPreview_D67_THADS);
  app.component('ReportParam_S06a_THA', ReportParam_S06a_THA);
  app.component('ReportParam_S06_THA_QT', ReportParam_S06_THA_QT);
  app.component('ReportParam_S07_THA', ReportParam_S07_THA);
  app.component('ReportParam_B04THA', ReportParam_B04THA);
  app.component('ReportParam_S06_THA', ReportParam_S06_THA);
  app.component('ReportParam_S08_THA', ReportParam_S08_THA);
  app.component('ReportPreview_S08_THA', ReportPreview_S08_THA);
  app.component('ReportParam_S04_THA', ReportParam_S04_THA);
  app.component('ReportParam_S03_THA_Ledger', ReportParam_S03_THA_Ledger);
  app.component('ReportParam_s02_tha_so_cai', ReportParam_s02_tha_so_cai);
  app.component('ReportParam_s02_tha_so_cai_qt', ReportParam_s02_tha_so_cai_qt);
  app.component('ReportParamC24THADS', ReportParamC24THADS);
  app.component('ReportParamC25THADS', ReportParamC25THADS);
  app.component('ReportParam_S09_THA', ReportParam_S09_THA);
  app.component('ReportParam_SummaryVoucher', ReportParam_SummaryVoucher);
  app.component('ReportParam_MS19', ReportParam_MS19);
  app.component('ReportParam_SummarySameTypeVoucher', ReportParam_SummarySameTypeVoucher);
  app.component('ReportParam_s08', ReportParam_s08);
  app.component('ReportParam_B03_THA_TM', ReportParam_B03_THA_TM);
  app.component('ReportParam_B05K', ReportParam_B05K);
  app.component('ReportParam_B04', ReportParam_B04);
  app.component('ReportParam_B04a', ReportParam_B04a);
  app.component('ReportParam_B04a_QD2030', ReportParam_B04a_QD2030);
  app.component('ReportParam_B01_EnforcementResult', ReportParam_B01_EnforcementResult);
  app.component('ReportParam_B05THA_AssetBalance', ReportParam_B05THA_AssetBalance);
  app.component('ReportPreview_B05THA_AssetBalance', ReportPreview_B05THA_AssetBalance);
  app.component('ReportPreview_SummaryVoucher', ReportPreview_SummaryVoucher);
  app.component('ReportPreview_S01_THA_QT', ReportPreview_S01_THA_QT);
  app.component('ReportPreview_s02_tha_so_cai_qt', ReportPreview_s02_tha_so_cai_qt);
  app.component('ReportPreview_AdvancePaymentQD2030', ReportPreview_AdvancePaymentQD2030);
  app.component('ReportPreview_AdvancePayment', ReportPreview_AdvancePayment);
  app.component('ReportPreview_s08', ReportPreview_s08);
  app.component('ReportPreview_S01_THA', ReportPreview_S01_THA);
  app.component('ReportPreview_S09_THA', ReportPreview_S09_THA);
  app.component('ReportPreview_StatisticsAccountingDocuments', ReportPreview_StatisticsAccountingDocuments);
  app.component('ReportPreview_s02_tha_so_cai', ReportPreview_s02_tha_so_cai);
  app.component('ReportPreview_B04_THA_QT', ReportPreview_B04_THA_QT);
  app.component('ReportPreview_B04_THA', ReportPreview_B04_THA);
  app.component('ReportPreview_B07_THA', ReportPreview_B07_THA);
  app.component('ReportPreview_S06_THA', ReportPreview_S06_THA);
  app.component('ReportPreview_S04_THA', ReportPreview_S04_THA);
  app.component('ReportPreview_S07_THA', ReportPreview_S07_THA);
  app.component('ReportPreview_S06_THA_QT', ReportPreview_S06_THA_QT);
  app.component('ReportParam_Stat_Justice_Decision', ReportParam_Stat_Justice_Decision);
  app.component('ReportParam_Pamphlet', ReportParam_Pamphlet);
  app.component('ReportPreview_S05_THA', ReportPreview_S05_THA);
  app.component('ReportParam_C01_THA', ReportParam_C01_THA);
  app.component('SettingPrintVoucher', SettingPrintVoucher);
  app.component('PrintBatchVoucher', PrintBatchVoucher);
}